'use strict';
import gsap from 'gsap';

const $ = jQuery.noConflict();
$(function() {

	const carousel = {

		init: function() {
			document.querySelectorAll('.js-carousel-row').forEach(ticker => {
				const inner = ticker.querySelector('.js-carousel-wrap');
				const content = inner.querySelector('.js-carousel-item-wrap');
				const duration = 60;
				inner.append(content.cloneNode(true));

				const animations = [];
				inner.querySelectorAll('.js-carousel-item-wrap').forEach(element => {
					const animation = gsap.to(element, {
						x: '-100%',
						repeat: -1,
						duration: duration,
						ease: 'linear'
					});
					animations.push(animation);
				});

				// ticker.addEventListener('mouseenter', () => {
				// 	animations.forEach(anim => anim.pause());
				// });

				// ticker.addEventListener('mouseleave', () => {
				// 	animations.forEach(anim => anim.play());
				// });
			});
		},
	};

	carousel.init();

});
